/**
 * @license @tabler/icons-vue v3.28.1 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createVueComponent from '../createVueComponent.mjs';

var IconKeyframeAlignHorizontalFilled = createVueComponent("filled", "keyframe-align-horizontal-filled", "IconKeyframeAlignHorizontalFilled", [["path", { "d": "M12 6c-.629 0 -1.214 .301 -1.606 .807l-2.908 3.748a2.395 2.395 0 0 0 -.011 2.876l2.919 3.762c.39 .505 .977 .807 1.606 .807c.629 0 1.214 -.301 1.606 -.807l2.908 -3.748a2.395 2.395 0 0 0 .011 -2.876l-2.919 -3.762a2.032 2.032 0 0 0 -1.606 -.807z", "key": "svg-0" }], ["path", { "d": "M5 11a1 1 0 0 1 .117 1.993l-.117 .007h-2a1 1 0 0 1 -.117 -1.993l.117 -.007h2z", "key": "svg-1" }], ["path", { "d": "M21 11a1 1 0 0 1 .117 1.993l-.117 .007h-2a1 1 0 0 1 -.117 -1.993l.117 -.007h2z", "key": "svg-2" }]]);

export { IconKeyframeAlignHorizontalFilled as default };
//# sourceMappingURL=IconKeyframeAlignHorizontalFilled.mjs.map
